<!-- src/App.vue -->
<!-- src/App.vue -->
<template>
  <div id="app">
    <!-- Renders pages via the router -->
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
};
</script>


<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
